export default __webpack_public_path__ + "static/media/logo1.64c38e36.png";